module.exports = __webpack_public_path__ + "img/05.f988b209.png";